import type { MasteryBand, MasteryStats } from '../types/progress'

export const updateMastery = (stats: MasteryStats, correct: boolean): MasteryStats => {
  const consecutiveCorrect = correct ? stats.consecutiveCorrect + 1 : 0
  const streakBonus = correct && consecutiveCorrect >= 3 ? 5 : 0
  return {
    correct: stats.correct + (correct ? 1 : 0),
    incorrect: stats.incorrect + (correct ? 0 : 1),
    consecutiveCorrect,
    lastPracticed: new Date().toISOString(),
    masteryScore: Math.max(0, Math.min(100, stats.masteryScore + (correct ? 10 + streakBonus : -5))),
  }
}

export const getMasteryBand = (score: number): MasteryBand => score >= 80 ? 'mastered' : score >= 40 ? 'learning' : 'needsPractice'
